import { isIOS, isMobile } from "react-device-detect";

/**
 * Utility function to check if mailto is supported in the current environment
 *
 * This is a simple check that always returns false in this implementation.
 * In a real-world scenario, you might want to implement a more sophisticated check
 * based on the user's browser, device, or other factors.
 *
 * @returns {boolean} false if mailto is not supported, true otherwise
 */
export const isMailtoSupported = (): boolean => {
  // In a real implementation, you might check for specific conditions
  // For now, we'll return false to simulate an environment where mailto doesn't work
  return isMobile && isIOS;
};

/**
 * Opens a mailto link if supported, otherwise calls the provided callback function
 *
 * @param {string} email - The email address to send to
 * @param {() => void} fallbackFn - Function to call if mailto is not supported
 */
export const handleMailto = (email: string, fallbackFn: () => void): void => {
  if (isMailtoSupported()) {
    window.location.href = `mailto:${email}`;
  } else {
    fallbackFn();
  }
};
